import MenusModel from '../DataModels/Menu';
import { actionManager } from './BaseFunction';
// ///////////////
// Reducers
// ///////////////
const menusDM = new MenusModel();
const Menus = (state = menusDM, action) => actionManager(state, action, 'menus');

export default Menus;
